module.exports = __webpack_public_path__ + "media/05c.3f472fce.mp4";